//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, filter, reduce } from 'lodash'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { salesControlActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { SalesControlStatus } from './Components'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseCheckAll from '../../hooks/UseCheckAll'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import userPrivileges from '../../constants/PrivilegesList'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////

import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`

//////STYLED//////

const SalesControl = () => {
	const { user, translations, salesControl, salesControlFilters, userKioskPerimeter, isSearchfieldUpdated, currentColumn, currentDir } =
		useSelector(
			(state) => ({
				translations: state.languages.translations,
				salesControl: state.salesControl,
				salesControlFilters: state.salesControl.header,
				user: state.user,
				userKioskPerimeter: state.user.identity.kioskSelected,
				isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
				currentColumn: state.columns.currentColumn,
				currentDir: state.columns.currentDir,
			}),
			shallowEqual
		)
	const actionsSalesControl = bindActionCreators(salesControlActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'labelToManufacturer', nameDir: 'asc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [configTable, setConfigTable] = useState({})

	// Columns
	const [columns, setColumns] = useState([])

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingSalesControl = (paging) => {
		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		/* 	let pg = cloneDeep(paging)
			//if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '250',
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'labelToManufacturer',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			} */
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'labelToManufacturer',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		//}
		setPaging(pg)

		actionsSalesControl.getSalesControl(handleFilterSend(), pg)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmitFilter = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'labelToManufacturer', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsSalesControl.getSalesControl(handleFilterSend(), pg)
	}
	const handleFilterSend = () => {
		// Prepping stores and kiosks selected
		// In UI, stores and kiosks are independant in listing and selection
		// But here, we need to regroup kiosks with their stores
		// {
		// 	"selectedStoreId": 4,
		// 	"selectedKiosksIds": [3,2]
		// },
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}

		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		let arr_selectedStoresKiosksIds = []
		map(filters.availableStores, (store) => {
			let rst = {}
			if (store.active) {
				rst.selectedStoreId = store.id

				// Extract kiosks
				let kiosks = map(filter(store.availableKiosks, { active: true }), 'id')
				rst.selectedKiosksIds = kiosks
			}

			if (!isEmpty(rst)) arr_selectedStoresKiosksIds.push(rst)
		})

		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'KioskTransactionAnalysis_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__kiosk__transactionAnalysis__tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToManufacturer',
			},
			{
				columnReferential: 'KioskTransactionAnalysis_clientKioskName',
				dataHook: 'customerKioskCode',
				headerName: translations['page__kiosk__transactionAnalysis__tableHeader_customerKioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'labelToOwner',
			},
			{
				columnReferential: 'KioskTransactionAnalysis_kioskName',
				dataHook: 'kioskLabel',
				headerName: translations['page__kiosk__transactionAnalysis__tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'description',
			},
			{
				columnReferential: 'KioskTransactionAnalysis_lastSaleDate',
				dataHook: 'lastValidatedSaleDate',
				headerName: translations['page__kiosk__transactionAnalysis__tableHeader_lastSaleDate'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					props.row.lastValidatedSaleDate === null || props.row.lastValidatedSaleDate === ''
						? '-'
						: moment(props.row.lastValidatedSaleDate).format('DD/MM/YYYY HH:mm'),
				sortableId: 'lastSaleOrderDate',
			},
			{
				columnReferential: 'KioskTransactionAnalysis_saleStatus',
				dataHook: 'lastSaleValidated',
				headerName: translations['page__kiosk__transactionAnalysis__tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				component: SalesControlStatus,
				sortableId: 'isLastSaleOrderValidated',
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 29,
		labelPageTable: 'KioskTransactionAnalysis',
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	//Config

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},

		paging: {
			fnSendTo: (paging) => handlePagingSalesControl(paging),
		},
	})

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(salesControl) && !isUndefined(salesControl)) {
			cfg.paging = {
				totalElements: salesControl.paging.totalElements,
				totalPages: salesControl.paging.totalPages,
				fnSendTo: (paging) => handlePagingSalesControl(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [salesControl])

	useEffect(() => {
		setFilters(salesControlFilters)
		setPrevFilter(salesControlFilters)
	}, [salesControlFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = [
			<TooltipHelp content={'tooltip__admin__page__subTitle__transactionAnalysis_view'} childrenPos={1} key={1}>
				{translations['page__kiosk__transactionAnalysis__tableTitle']}
			</TooltipHelp>,
		]

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__kiosk__transactionAnalysis__filters_status']}
					data={filters.filtersSelection?.statuses.filterElements}
					paperTopPos
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmitFilter}
					target={'statuses'}
				/>
			),
		]

		cfg.paging = {
			totalElements: salesControl.paging.totalElements,
			totalPages: salesControl.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesControl(paging),
		}

		setConfigTableTitle(cfg)
	}, [translations, filters])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[23],
			url: urlExport[21],
			bd: {
				withFilters: true,
				filtersSelection: filters.filtersSelection,
				searchField: searchValue,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		return function cleanUp() {
			actionsSalesControl.resetSalesControlItems()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const userCp = cloneDeep(user)
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			const filtersCp = {
				withFilters: false,
				searchField: searchValue,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},

				searchFieldUpdated: searchValue?.length > 0 ? true : false,
			}

			actionsSalesControl.getSalesControl(filtersCp)
			setFilters(filtersCp)
			actionsColumns.setColumns([])
		}
	}, [swytch, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsSalesControl.getSalesControl(
				{
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: reduce(
							user.identity.kioskSelected,
							(result, value) => {
								result.push(value.id)
								return result
							},
							[]
						),
					},

					pricesTTC: user.identity.isPricesTTC,
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	// we make a guard to prevent 2 back call
	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmitFilter()
	}, [filters.searchField])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={salesControl.items}
				inputConfig={configTable}
				isLoading={salesControl.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsSalesControl.getSaleControl}
			/>
		)
	}, [salesControl, columns, configTable, translations, paging])
	return (
		<Fragment>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

SalesControl.propTypes = {}

SalesControl.defaultPropTypes = {}

export default SalesControl
